module.exports = __webpack_public_path__ + "emoji.svg?fa146ab7d9a12c6030f1e4deb0875f49";